import {isInPage, appear} from './functions.js';

if(isInPage(document.getElementById("services-section"))){
  var service_titles = document.getElementsByClassName('service-title');
  var service_thumbnails = document.getElementsByClassName('service-thumbnail');


  for(var i = 0;i < service_titles.length; i++){
    service_titles.item(i).addEventListener("mouseover", function(event){
      var service_id = event.target.getAttribute('data-service-id');

      for(let j = 0;j < service_thumbnails.length;j++){
        if(service_thumbnails.item(j).getAttribute('data-service-id') == service_id){
          service_thumbnails.item(j).style.display = 'block';
          service_thumbnails.item(j).style.opacity = 0;
          appear(service_thumbnails.item(j),0,10,50);
        } else{
          service_thumbnails.item(j).style.display = 'none';
          service_thumbnails.item(j).style.opacity = 0;
        }
      }
    });
  }
}
